import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Button } from '@material-ui/core';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    button: {
        backgroundColor: 'black',
        marginRight: theme.spacing(1),
        '&:hover': {
            backgroundColor: "rgba(50, 50, 50, 1)",
        },
    },
    Info: {
        color: '#CC8500',
        fontSize: '14px',
        marginTop: '10px',
        marginLeft: '10px',
        textShadow: '.5px .5px #CC8500',
        animation: '$blinker 3s linear infinite'
    },
    '@keyframes blinker': {
        '50%': { opacity: 0 }
    }
}));

const Header = ({ setApplicationFlow }) => {
    const { t } = useTranslation()
    const classes = useStyles()
    return (
        <AppBar style={{ backgroundColor: '#ECECEC', opacity: '.8' }}>
            <Toolbar>
                <Box display="flex" alignItems="center">
                    <IconButton edge="start" color="inherit" aria-label="menu">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" alt="Logo" style={{ height: '40px', width: 'auto' }} />
                    </IconButton>
                    
                    <Box ml={1} sx={{ color: 'black', textAlign: 'center' }}>
                        <Typography variant="h6" noWrap>
                            {t('Uttar Pradesh')}
                        </Typography>
                        <Typography variant="subtitle2" noWrap>
                            {t('THE_OFFICIAL_WEBSITE')}
                        </Typography>
                    </Box>
                </Box>


                <Box display="flex" gap={2} textAlign="center" justifyContent="flex-end" flexGrow={1} sx={{ color: 'black' }}>
                    <Button onClick={() => setApplicationFlow("AVP")}
                        variant="contained"
                        className={classes.button}
                        // style={{backgroundColor: 'rgba(13, 13, 13, 0.7)', color: 'white'}}
                        style={{
                            backgroundColor: '#CC8500',
                            color: 'white',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 165, 0, 0.9)',
                            },
                        }}
                    >
                        {t('Awas Evam Vikas Parishad')}
                    </Button>

                    <Button onClick={() => setApplicationFlow("DA")}
                        variant="contained"
                        className={classes.button}
                        // style={{backgroundColor: 'rgba(13, 13, 13, 0.7)', color: 'white'}}
                        style={{
                            backgroundColor: '#CC8500',
                            color: 'white',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 165, 0, 0.9)',
                            },
                        }}
                    >
                        {t('Development Authority')}
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
